import { z } from "zod";

export const answerSchema = z.object({
  taskId: z.string().uuid(),
  message: z.string().trim().min(3, "Écrivez au moins 3 caractères").max(255, "Maximum 255 caractères"),
  statut_tache: z.enum(["En Cours", "Traité", "Rejeté"]),
  files: z.any().optional(),
});

export type AnswerFormData = z.infer<typeof answerSchema>;
